import { ContextNotification, Span } from '@pandiafi/design-system'
import { t } from 'i18next'
import React from 'react'

export const ResendVerificationCodeSuccessSection: React.FC<{
  resendTime: string
}> = ({ resendTime }) => (
  <ContextNotification type="warning">
    <Span light>
      {t('registration:verificationCodeResendStatus', {
        time: resendTime,
      })}
    </Span>
  </ContextNotification>
)
